module.exports = __webpack_public_path__ + "img/hc_pro_night_1.d2e1d243.jpg";